import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { TEMPLATE_KEYS } from './queryKeys';

export function useSaveFormAsTemplate(formId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (title?: string) => formsService.saveAsTemplate(formId, title),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEMPLATE_KEYS.byOrg(orgId ?? '') });
    },
  });
}
